<template>
    <div id="main" :class="sidebarFold ? 'sidebarFoldShrink' : ''" v-loading="loading" element-loading-text="切换中，请稍后...">
        <TopToolbar @showRight="showRight" @showPersonal="showPersonal" @switchTenants="switchTenants"/>
        <el-container class="el-container-main">
            <LeftMenu/>
            <CenterMainContent v-if="refreshPage"/>
        </el-container>
        <RightOption ref="mainRight"/>
        <PersonalCenter ref="personalCenter" @showPersonal="showPersonal"/>

        <!--引导-->
        <div class="guideBox" v-if="resourcesDetailsGuide">
            <div class="guideItem" v-if="guideStep == 1">
                <el-image class="guideBtn1" :src="require('@/assets/img/guideBtn1.png')"></el-image>
                <div class="guideInfoBox">
                    <div class="w100 h100 p_r">
                        <el-image class="guideClose" :src="require('@/assets/img/guideClose.png')" @click="guideClose()"></el-image>
                        <el-image class="w100" :src="require('@/assets/img/guideInfo1.png')"></el-image>
                        <div class="guideNext" @click="guideStep++">下一步</div>
                    </div>
                </div>
            </div>
            <div class="guideItem" v-if="guideStep == 2">
                <el-image class="guideBtn2" :src="require('@/assets/img/guideBtn2.png')"></el-image>
                <div class="guideInfoBox2">
                    <div class="w100 h100 p_r">
                        <el-image class="guideClose" :src="require('@/assets/img/guideClose.png')" @click="guideClose()"></el-image>
                        <el-image class="w100" :src="require('@/assets/img/guideInfo2.png')"></el-image>
                        <div class="guideNext" @click="guideStep++">下一步</div>
                    </div>
                </div>
            </div>
            <div class="guideItem" v-if="guideStep == 3">
                <el-image class="guideBtn1" :src="require('@/assets/img/guideBtn3.png')"></el-image>
                <div class="guideInfoBox">
                    <div class="w100 h100 p_r">
                        <el-image class="guideClose" :src="require('@/assets/img/guideClose.png')" @click="guideClose()"></el-image>
                        <el-image class="w100" :src="require('@/assets/img/guideInfo3.png')"></el-image>
                        <div class="guideNext" @click="guideClose()">知道了</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopToolbar from './layout/TopToolbar'
    import LeftMenu from './layout/LeftMenu'
    import CenterMainContent from './layout/CenterMainContent'
    import RightOption from './layout/RightOption'
    import PersonalCenter from './layout/PersonalCenter'

    export default {
        data() {
            return {
                isRightVisible: false,
                isPersonalVisible: false,
                refreshPage: true,
                guideStep: 1,
                loading: false,
            }
        },
        components: {
            TopToolbar,
            LeftMenu,
            CenterMainContent,
            RightOption,
            PersonalCenter
        },
        computed: {
            // 菜单栏缩放
            sidebarFold: {
                get() {
                    return this.$store.state.common.sidebarFold
                }
            },
            // 页签数据
            resourcesDetailsGuide: {
                get() {
                    return this.$store.state.common.resourcesDetailsGuide
                },
                set(val) {
                    this.$store.commit('common/updateResourcesDetailsGuide', val)
                }
            },
        },
        watch: {
            // 监听路由
            $route: {
                handler() {
                    this.refresh()
                },
                deep:true,
                immediate: true
            },
        },
        mounted() {
        },
        methods: {
            refresh() {
                this.refreshPage = false
                this.$nextTick(() => (this.refreshPage = true))
            },
            showPersonal(flag) {
                this.$refs.personalCenter.showPersonal(flag);
                this.isPersonalVisible = flag;
            },
            // 切换租户
            switchTenants(flag) {
                this.loading = flag
            },
            // 显示右边配置
            showRight(flag) {
                this.$refs.mainRight.showRight();
                this.isRightVisible = flag;
            },
            // 关闭引导
            guideClose() {
                this.$axios(this.api.user.updateById, {}, 'post').then(data => {
                    if (data.status) {
                        this.resourcesDetailsGuide = false
                    }
                })
            },
        }
    }
</script>
